import { axiosPrivate } from '../../api/axios';
import {
    setTasksLoading,
    setTasksData,
    setTasksError,
    upsertTask,
    applyTaskSubmission,
    applyTaskGrade,
} from '../reducers/tasks';

export const fetchCourseTasks = (courseId) => async (dispatch) => {
    dispatch(setTasksLoading(true));
    try {
        const response = await axiosPrivate.get(`/api/tasks/courses/${courseId}`);
        if (response.status === 200) {
            dispatch(setTasksData(response.data));
        }
    } catch (error) {
        dispatch(setTasksError(
            error?.response?.data?.message || 'No se pudieron cargar las tareas.',
        ));
    }
};

export const createCourseTask = (courseId, payload) => async (dispatch) => {
    const response = await axiosPrivate.post(`/api/tasks/courses/${courseId}`, payload);
    if (response.status === 201) {
        dispatch(upsertTask(response.data.task));
        return response.data.task;
    }
    return null;
};

export const updateCourseTask = (taskId, payload) => async (dispatch) => {
    const response = await axiosPrivate.patch(`/api/tasks/${taskId}`, payload);
    if (response.status === 200) {
        dispatch(upsertTask(response.data.task));
        return response.data.task;
    }
    return null;
};

/** Detalle de una tarea; no se guarda en Redux, lo consume el drawer directamente. */
export const fetchTaskDetail = (taskId) => async () => {
    const response = await axiosPrivate.get(`/api/tasks/${taskId}`);
    return response.data.task;
};

/** Roster de entregas (solo profesor dueño). */
export const fetchTaskSubmissions = (taskId) => async () => {
    const response = await axiosPrivate.get(`/api/tasks/${taskId}/submissions`);
    return response.data;
};

export const fetchTaskSubmissionDetail = (taskId, submissionId) => async () => {
    const response = await axiosPrivate.get(`/api/tasks/${taskId}/submissions/${submissionId}`);
    return response.data.submission;
};

export const submitCourseTask = (taskId, payload) => async (dispatch) => {
    const response = await axiosPrivate.post(`/api/tasks/${taskId}/submissions`, payload);
    if (response.status === 201) {
        dispatch(applyTaskSubmission({ taskId, submission: response.data.submission }));
        return response.data.submission;
    }
    return null;
};

export const getTaskPresignedUploadUrl = (courseId, { fileName, mimeType, size }) => async () => {
    const response = await axiosPrivate.post('/api/tasks/uploads/presign', {
        courseId,
        fileName,
        mimeType,
        size,
    });
    return response.data;
};

export const gradeCourseTaskSubmission = (taskId, submissionId, payload) => async (dispatch) => {
    const response = await axiosPrivate.patch(`/api/tasks/${taskId}/submissions/${submissionId}`, payload);
    if (response.status === 200) {
        dispatch(applyTaskGrade({
            taskId,
            submission: response.data.submission,
            gradedCount: response.data.gradedCount,
        }));
        return response.data.submission;
    }
    return null;
};
